import Home from "./pages/Contact/Home";

const Contact = ({ lang }) => {
  return <Home lang={lang} />;
};

export default Contact;
